import {
  collection,
  getFirestore,
  onSnapshot,
  query,
  where,
} from "firebase/firestore"
import { useEffect, useState } from "react"

const useMyDocuments = (userId) => {
  const [documents, setDocuments] = useState([])

  useEffect(() => {
    if (!userId) return
    const db = getFirestore()
    const q = query(collection(db, "documents"), where("userId", "==", userId))
    const unsubscribe = onSnapshot(q, (qs) => {
      const docs = qs.docs
        .map((d) => d.data())
        .sort((a, b) => {
          const aTime =
            (a._createdAt?.toDate ? a._createdAt.toDate() : a._createdAt) || 0
          const bTime =
            (b._createdAt?.toDate ? b._createdAt.toDate() : b._createdAt) || 0
          return (bTime?.getTime?.() || 0) - (aTime?.getTime?.() || 0)
        })
      setDocuments(docs)
    })
    return () => unsubscribe()
  }, [userId])

  return documents
}

export default useMyDocuments
